module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAAXNSR0IArs4c6QAAAEVQTFRFAAAAIGDvKmrvLGjrKWnsKWXrKmjsLGjtLGjrK2jsK2nsKmbrLGjsLGnrK2nsLGnsLGjrLGjsLGjrK2jsK2jrK2jsLGnsVT8+iAAAABR0Uk5TABAwQFBYYH+AkKClv8Dg7/Dw/P70gMopAAAAgUlEQVQoz73S3Q6DIAyG4XY/6DoZ1M3v/i91FjCrwTOTvQeE+JA0EImfC/a972QJ5pzxmdeAbGEJBlBbYtmiHA1A2L7tgIKaHABdFGOD2ot+UiHE0m0Dig26/gmPyTU4UP+I6oCvLj41XOrYsYM2PJ68YDoC1fVnSFNXghCLokuFvxKnEH69SnoSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/fj-keep.png
// module id = tGBp
// module chunks = 0